import { isEmpty } from "lodash";
import { useLocation, matchPath } from "react-router";
import { useTermAccessRights } from "../hooks/authorisation/useTermAccessRights";
import { useAuthorisedEntities } from "../hooks/authorisation/useAuthorisedEntities";
import findTermFromPath from "../utils/findTermFromPath";
function useRouteWithAuthZMiddleware(isAuthorizedPage, config) {
    var exceptedAuthorizedPages = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var pathname = useLocation().pathname;
    var term = findTermFromPath(config, pathname);
    var authorizedEntities = useAuthorisedEntities();
    var ref;
    var hasTermAccess = useTermAccessRights((ref = term === null || term === void 0 ? void 0 : term.pamPermKey) !== null && ref !== void 0 ? ref : "");
    var isExceptedPage = exceptedAuthorizedPages.some(function(path) {
        var match = matchPath(pathname, {
            path: path
        });
        return (match === null || match === void 0 ? void 0 : match.path) === path || pathname.includes(path);
    });
    if (!isAuthorizedPage(pathname) || isExceptedPage) return {
        isAuthorized: true,
        isLoading: false
    };
    return {
        isLoading: isEmpty(authorizedEntities),
        isAuthorized: !isEmpty(hasTermAccess)
    };
}
export default useRouteWithAuthZMiddleware;

//# sourceMappingURL=useRouteWithAuthZMiddleware.js.map